export const LOCALSTORAGES = {
  ACCESS_PLATFORM_ON: 'access-plataform-on',
  DATE_INIT_QUIZZ: 'date-init-quizz',
  // Fuera de removeAllStorage a propósito: sobrevive al borrado de la sesión para que /logout
  // pueda devolver al usuario SSO a su portal (TAN-11526).
  SSO_PORTAL_FALLBACK: 'sso-portal-fallback',
};
